module.exports = __webpack_public_path__ + "static/tabaxi-axe-ayagww-69a7c4b195f1aebebe26e1a778444482.jpg";